import NotepadTextSvg from '@assets/images/svg/notepad-text.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface NotepadTextIconProps {
    size?: number;
    color?: string;
}

export const NotepadTextIcon: React.FC<NotepadTextIconProps> = ({
    size = 24,
    color = '#333333',
}) => {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <NotepadTextSvg
                width={size}
                height={size}
                color={color}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default NotepadTextIcon;
